import store from "@/store";

export enum GA_SIGN_UP_SCENE {
    SIGN_UP_POPUP_SHOWN = 'In_product_new_sign_up_window',
    SIGN_UP_POPUP_CLOSED = 'In_product_new_sign_up_window_close',
    SIGN_UP_POPUP_CREATE_BTN_CLICKED = 'In_product_create_my_account_button',
    SIGN_UP_POPUP_SIGN_UP_SUCCESS = 'In_product_create_my_account_successful',
    SIGN_UP_POPUP_SIGN_UP_FAIL = 'In_product_create_my_account_failed',
    SIGN_UP_POPUP_LOGIN_BTN_CLICKED = 'In_product_login_button',
    SIGN_UP_POPUP_TO_LOGIN_SUCCESS = 'In_product_login_successful',
    SIGN_UP_POPUP_TO_LOGIN_INTERRUPTED = 'In_product_login_interrupted',
}

const GA_SIGN_UP_POPUP_LABEL = 'In_product_new_sign_up_window';
const GA_SIGN_UP_POPUP_CATEGORY = 'Conversion_Improvement';
const CATEGORY_LABEL = {
    category: GA_SIGN_UP_POPUP_CATEGORY,
    label: GA_SIGN_UP_POPUP_LABEL
}
function genGAObject(scene: GA_SIGN_UP_SCENE) {
    return {
        eventKey: scene,
        action: scene,
        ...CATEGORY_LABEL
    }
}

export function sendGA(scene: GA_SIGN_UP_SCENE) {
    const event = genGAObject(scene);
    store.userStore.doSendGAEvent(event as any);
}
